export const CARD_BRANDS = ["visa", "amex", "mastercard", "cup", "jcb", "maestro", "discover"]
